module.exports = __webpack_public_path__ + "static/media/sendMessage.22f2a488.svg";